//gsap.registerPlugin(ScrollTrigger);
( function () {
  'use strict';
  ( function ( $ ) {
    $(function() {
      var rellax = new Rellax('.rellax',{
        center:true,
        horizontal:false,
      });
    });    
  })( jQuery );
})();